export const getProjectNavigationRouteKey = (asPath: string) => {
  const pathname = asPath.split(/[?#]/)[0];
  return pathname.replace(/\/+$/, "") || "/";
};
